import { Pipe, PipeTransform } from '@angular/core';
import type { CardData } from '../../../models/print-cards/card-data';
import type { CardsThatLayoutOntoPaper } from '../../../models/menu/section/cards-that-layout-onto-paper';
import { ShelfTalkerCardData } from '../../../models/shelf-talkers/shelf-talker-card-data';

@Pipe({
  name: 'leftCutLineText',
  standalone: false
})
export class LeftCutLineTextPipe implements PipeTransform {
  transform(
    cardsThatLayoutOntoPaper: CardsThatLayoutOntoPaper,
    cardsOnPage: CardData[] | ShelfTalkerCardData[],
    i: number
  ): string | null {
    return cardsThatLayoutOntoPaper?.getLeftCutLineText(cardsOnPage?.[i]);
  }
}
